module.exports = __webpack_public_path__ + "static/img/Ifeyinwa-Frederick.3a0eba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/Ifeyinwa-Frederick.png
// module id = 54zd
// module chunks = 0